module.exports = __webpack_public_path__ + "img/17_99.559fe57a.png";